module.exports = __webpack_public_path__ + "4e105b8535f0de9e895b953f85df9257.svg";